import { AfterViewInit, Component, ElementRef, HostListener, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core'
import { RouterModule } from '@angular/router'
import { CommonModule } from '@angular/common'
import { Subscription } from 'rxjs/internal/Subscription'
import { Banner } from '../../../../core/models/metrics.model'
import { ScoresService } from '../../../scores/services/scores.service'
import { MatIconModule } from '@angular/material/icon'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { MatchService } from 'src/app/core/services/matches.service'
import { MatButtonModule } from '@angular/material/button'

@Component({
    selector: 'minicalendar-component',
    standalone: true,
    imports: [
      CommonModule,
      RouterModule,
      MatProgressSpinnerModule,
      MatIconModule,
      MatButtonModule
    ],
    templateUrl: 'minicalendar.component.html',
    styleUrl: './calendar.component.css'
})
export class MiniCalendarComponent implements AfterViewInit {
  @ViewChildren('matchContainer') matchContainers!: QueryList<ElementRef>

  calendar: any[] = []

  constructor(
    private service: MatchService,
  ){}

  ngAfterViewInit() {
    this.service.getCalendar()
    .subscribe(response => {
      var matches = (response as any[]).slice(0, 3) 
      if (matches && matches.length > 0){
        this.calendar = matches.map(item => ({
          ...item,
          showTeamName: true
        }))
        setTimeout(()=>this.checkWidths(),0)
      }
    })
  }

  @HostListener('window:resize')
  onResize() {
    this.checkWidths()
  }

  checkWidths() {
    if (!this.matchContainers || this.matchContainers.length === 0) return

    this.matchContainers.forEach((elRef, index) => {
      const width = elRef.nativeElement.offsetWidth
      this.calendar[index].showTeamName = width > 370
    })
  }

  getColor(competition:string){
    var color = '#c30913'
    switch(competition){
      case 'Champions League':
      case 'Friendly':
        color = '#4464ad'
        break
      case 'Copa del Rey':
        color = '#121215'
        break
    }
    return `linear-gradient(80deg, ${color} 2%, transparent 22%)`
  }
  getFoto(competition:string){
    switch(competition){
      case 'LALIGA':
        return 'https://assets.laliga.com/assets/logos/LL_RGB_h_monocromo_positivo/LL_RGB_h_monocromo_positivo.png'
      case 'Champions League':
        return 'https://i.pinimg.com/originals/5f/32/84/5f32846ad37b4e9a20fb3bcd085bc0d8.png'
      case 'Copa del Rey':
        return 'https://brandlogos.net/wp-content/uploads/2022/08/copa_del_rey-logo_brandlogos.net_mm7fh.png'
      case 'Primera RFEF':
        return 'https://upload.wikimedia.org/wikipedia/commons/thumb/d/d2/Primera_Federaci%C3%B3n.svg/1200px-Primera_Federaci%C3%B3n.svg.png'
      case 'Youth League':
        return 'https://upload.wikimedia.org/wikipedia/commons/thumb/8/82/UEFA_Youth_League.svg/2048px-UEFA_Youth_League.svg.png'
      case 'FIFA Club World Cup':
        return 'https://atleticostats.fra1.cdn.digitaloceanspaces.com/logos/ClubWorldCup.png'
      case 'Torneo Futbol Callejero':
        return 'https://atleticostats.fra1.cdn.digitaloceanspaces.com/logos/TorneoFutbolCallejero.png'
      case 'Friendly':
        return 'https://atleticostats.fra1.cdn.digitaloceanspaces.com/logos/FriendlyMatch.png'
      default:
        return ''
    }
  }
}